import axios from "axios";
import { baseUrl, portal } from "../App";

export const fetchReferralHistory = async (token) => {
  const res = await axios.get(`${baseUrl}/weeklyRefRecord/?portal=${portal}`, {
    headers: { Authorization: `Token ${token}` }
  });
  return res.data;
}